import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCsrfToken } from "../services/authService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../styles/EditProfile.css";

export default function ChangePassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (form.newPassword !== form.confirmPassword) {
      setError(t("changePassword.passwordsDontMatch"));
      return;
    }

    try {
      const csrf = await getCsrfToken();

      const response = await fetch("/api/profile/change-password", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          [csrf.headerName]: csrf.token,
        },
        body: JSON.stringify({
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        }),
      });

      if (response.status === 400) {
        setError(t("changePassword.invalidCurrentPassword"));
        return;
      }

      if (!response.ok) {
        setError(t("changePassword.error"));
        return;
      }

      navigate("/profile", {
        replace: true,
        state: { passwordChanged: true },
      });
    } catch {
      setError(t("changePassword.error"));
    }
  };

  return (
    <main className="profile-page">
      <section className="profile-card">
        <h1>{t("changePassword.title")}</h1>
        <p className="profile-description">{t("changePassword.description")}</p>

        <form className="profile-form" onSubmit={handleSubmit}>
          <label>
            {t("changePassword.currentPassword")}

            <div className="password-field">
              <input
                type={showCurrentPassword ? "text" : "password"}
                name="currentPassword"
                value={form.currentPassword}
                onChange={handleChange}
                required
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() =>
                  setShowCurrentPassword(!showCurrentPassword)
                }
                aria-label="Mostrar contraseña"
              >
                {showCurrentPassword ? (
                  <FaEyeSlash />
                ) : (
                  <FaEye />
                )}
              </button>
            </div>
          </label>

          <label>
            {t("changePassword.newPassword")}

            <div className="password-field">
              <input
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                value={form.newPassword}
                onChange={handleChange}
                required
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() =>
                  setShowNewPassword(!showNewPassword)
                }
                aria-label="Mostrar contraseña"
              >
                {showNewPassword ? (
                  <FaEyeSlash />
                ) : (
                  <FaEye />
                )}
              </button>
            </div>
          </label>

          <label>
            {t("changePassword.confirmPassword")}

            <div className="password-field">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                required
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() =>
                  setShowConfirmPassword(!showConfirmPassword)
                }
                aria-label="Mostrar contraseña"
              >
                {showConfirmPassword ? (
                  <FaEyeSlash />
                ) : (
                  <FaEye />
                )}
              </button>
            </div>
          </label>

          {error && <p className="login-error">{error}</p>}

          <div className="profile-actions">
            <button type="submit">{t("changePassword.save")}</button>
            <button type="button" onClick={() => navigate("/profile")}>
              {t("changePassword.back")}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
}